import { useIsV2 } from "../../common/layout/v2/useIsV2";
import { OrganizationProfileUrls, urls } from "../../urls";

export const useOrganizationProfileUrls = (): OrganizationProfileUrls => {
  const isV2 = useIsV2();
  return isV2 ? urls.v2.organizationProfile : urls.organizations.profile;
};
